var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgProfilePhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.413 16.193a10.064 10.064 0 0 0 4.394 4.394l1.466-1.467a.67.67 0 0 1 .68-.167c.747.247 1.547.38 2.38.38A.667.667 0 0 1 22 20v2.333a.666.666 0 0 1-.667.667A11.333 11.333 0 0 1 10 11.667a.666.666 0 0 1 .667-.667H13a.666.666 0 0 1 .667.667c0 .833.133 1.633.38 2.38a.67.67 0 0 1-.167.68l-1.467 1.466Z",
  fill: "#0A0A0A"
})));
export default SvgProfilePhone;